<template>
    <div>
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout" :colon="false">
                        <a-form-model-item
                                ref="name"
                                label="运营时间"
                                prop="name"
                                :help="formErr.name"
                                :validateStatus='!formErr.name||formErr.name==""?"":"error"'
                        >
                            <a-input-number :min="1" :max="9999" class="inputNum"   v-model="form.name"  @change="(e) => { formErr.name='' ;}"
                                            :precision="0"     />
<!--                            @blur="(e) => {  form.name = e.target.value.trim();form.name = e.target.value.replace(/^(0+)|[^\d]/g, '') }"-->
                            <span class="fg">天以上</span>
                        </a-form-model-item>
                        <a-form-model-item
                                ref="value"
                                label="每30天UV标准值增长"
                                prop="value"
                                :help="formErr.value"
                                :validateStatus='!formErr.value||formErr.value==""?"":"error"'
                        >
                            <a-input-number :min="1" :max="999999" class="inputNum"  v-model="form.value"  @change="(e) => { formErr.value=''  }"
                                            :precision="0"   />
<!--                            @blur="(e) => {  form.value = e.target.value.trim();form.value = e.target.value.replace(/^(0+)|[^\d]/g, '') }"-->
                        </a-form-model-item>

            <a-form-model-item
                    label=" "
            >
                <a-button type="primary" @click="onSubmit">
                    保存
                </a-button>
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

        </div>
 </div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    export default {
        name: "uvAllForm",
        data() {
            return {
                drawerConfig ,
                form: {
                    name:"",
                    value:"",
                },
                formErr: {
                    name:"",
                    value:"",
                },
                rules: {
                    name: [{required: true, message: "请输入运营时间  ", trigger: "blur"},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  }, ],
                    value: [{required: true, message: "请输入每30天UV标准值增长 ", trigger: "blur"} ,{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.value)}  , trigger: "blur"  }, ],
                    },
                layout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 14 },
                },
            };
        },
        props:["num"],
        watch: {
            num:function(a,b){
                if(a==2){
                    this.form= { name:"", value:"", },
                    this.formErr={ name:"", value:"", },
                        this.$refs.ruleForm.resetFields(valid => {})
                    this.getFormData()
                    // resetFields

                }
            },},
            mounted(){
             this.getFormData()
            },
        methods: {
            getFormData(){
                API.service.ADD_DATA_UA().then(res => {
                    this.form.type=2
                    if(res.data.data==null){
                        this.form.id=0
                        return
                    }
                    this.form=res.data.data
                })
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        submitForm(API.service.SUBMIT_ADD_UV , _this.form).then(res => {
                            if (res == true) {
                            } else {
                                res.map((item, index) => {
                                    this.formErr["name"] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.citem{display: inline-block;width: 49%}
    .inputNum{width: 150px;display: inline-block}
    .fg{position: relative;left:20px;top: -2px}
    .citemb{display: block}
.ant-form-item-required {display: none!important;}
</style>
